import styled from 'styled-components';

export const StyledButton = styled.button`
	p {
		display: flex;
		align-items: center;
	}
`;

export const MoreInformationDialogHeaderStyles = styled.span`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
`;
